module.exports = __webpack_public_path__ + "static/media/changning-logo.d0745720.jpg";